export default __webpack_public_path__ + "static/DEHkaiTexni-small-76496e06f85121bb4073f2820b3f150e.pdf";